var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCreateFromTemplate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "228px",
    height: "228px",
    viewBox: "0 0 228 228",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "form")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.3.-Index-Builder---Create-New-Methodology---Paths-00",
    transform: "translate(-473.000000, -446.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(254.000000, 433.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "form",
    transform: "translate(219.964809, 14.263930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.970674,91.1172075 C225.970674,77.049209 214.525855,65.6043894 200.457856,65.6043894 L198.948728,65.6043894 L167.655662,96.8974553 L167.655662,0 L38.5824425,0 L0,38.5824425 L0,225.970674 L167.655662,225.970674 L167.655662,150.941349 L225.970674,92.6263362 L225.970674,91.1172075 Z M96.2710245,178.589727 L171.30035,103.560401 L177.080598,109.340649 L102.051272,184.369974 L96.2710245,178.589727 Z M93.694116,186.320452 L105.254612,197.880948 L91.7703329,199.80829 L93.694116,186.320452 Z M112.985337,195.304039 L107.205089,189.523792 L182.234415,114.494466 L188.014663,120.274714 L112.985337,195.304039 Z M176.454167,98.4065841 L182.234415,92.6263362 L198.948728,109.340649 L193.16848,115.120897 L176.454167,98.4065841 Z M36.446883,12.4431936 L36.446883,36.446883 L12.4431936,36.446883 L36.446883,12.4431936 Z M160.366285,218.681298 L7.2893766,218.681298 L7.2893766,43.7362596 L43.7362596,43.7362596 L43.7362596,7.2893766 L160.366285,7.2893766 L160.366285,104.186832 L87.6807361,176.872381 L83.1747054,208.400358 L114.702683,203.894328 L160.366285,158.230726 L160.366285,218.681298 Z M204.102545,104.186832 L187.388232,87.4725192 L201.908257,72.9524937 C210.801083,73.6554489 217.919615,80.7739807 218.62257,89.6668065 L204.102545,104.186832 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.26393,36.7859238 C148.264846,36.7859238 153.14956,31.9012098 153.14956,25.9002933 C153.14956,19.8993767 148.264846,15.0146628 142.26393,15.0146628 C136.263013,15.0146628 131.378299,19.8993767 131.378299,25.9002933 C131.378299,31.9012098 136.263013,36.7859238 142.26393,36.7859238 Z M142.26393,22.2717498 C144.262463,22.2717498 145.892473,23.9017595 145.892473,25.9002933 C145.892473,27.898827 144.262463,29.5288368 142.26393,29.5288368 C140.265396,29.5288368 138.635386,27.898827 138.635386,25.9002933 C138.635386,23.9017595 140.265396,22.2717498 142.26393,22.2717498 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.985337,36.7859238 C118.986254,36.7859238 123.870968,31.9012098 123.870968,25.9002933 C123.870968,19.8993767 118.986254,15.0146628 112.985337,15.0146628 C106.984421,15.0146628 102.099707,19.8993767 102.099707,25.9002933 C102.099707,31.9012098 106.984421,36.7859238 112.985337,36.7859238 Z M112.985337,22.2717498 C114.983871,22.2717498 116.613881,23.9017595 116.613881,25.9002933 C116.613881,27.898827 114.983871,29.5288368 112.985337,29.5288368 C110.986804,29.5288368 109.356794,27.898827 109.356794,25.9002933 C109.356794,23.9017595 110.986804,22.2717498 112.985337,22.2717498 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7067449,36.7859238 C89.7076614,36.7859238 94.5923754,31.9012098 94.5923754,25.9002933 C94.5923754,19.8993767 89.7076614,15.0146628 83.7067449,15.0146628 C77.7058283,15.0146628 72.8211144,19.8993767 72.8211144,25.9002933 C72.8211144,31.9012098 77.7058283,36.7859238 83.7067449,36.7859238 Z M83.7067449,22.2717498 C85.7052786,22.2717498 87.3352884,23.9017595 87.3352884,25.9002933 C87.3352884,27.898827 85.7052786,29.5288368 83.7067449,29.5288368 C81.7082111,29.5288368 80.0782014,27.898827 80.0782014,25.9002933 C80.0782014,23.9017595 81.7082111,22.2717498 83.7067449,22.2717498 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "58.5571848 44.2932551 153.14956 44.2932551 153.14956 51.8005865 58.5571848 51.8005865"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.2639296 57.8064516 153.14956 57.8064516 153.14956 65.313783 14.2639296 65.313783"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.2639296 204.199413 76.5747801 204.199413 76.5747801 211.706745 14.2639296 211.706745"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "69.0674487 189.184751 76.5747801 189.184751 76.5747801 196.692082 69.0674487 196.692082"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "15.0146628 189.184751 62.3108504 189.184751 62.3108504 196.692082 15.0146628 196.692082"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.2639296 174.170088 76.5747801 174.170088 76.5747801 181.677419 14.2639296 181.677419"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.2639296 160.656891 76.5747801 160.656891 76.5747801 168.164223 14.2639296 168.164223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.099707,73.5718475 L15.0146628,73.5718475 L15.0146628,153.14956 L102.099707,153.14956 L102.099707,73.5718475 Z M94.8426197,145.915223 L22.2717498,145.915223 L22.2717498,80.806185 L94.8426197,80.806185 L94.8426197,145.915223 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "108.856305 72.8211144 153.14956 72.8211144 153.14956 80.3284457 108.856305 80.3284457"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "108.856305 87.085044 153.14956 87.085044 153.14956 94.5923754 108.856305 94.5923754"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "108.856305 102.099707 153.14956 102.099707 153.14956 109.607038 108.856305 109.607038"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "29.2785924 123.870968 36.7859238 123.870968 36.7859238 131.378299 29.2785924 131.378299"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "36.5356794 94.4046921 51.0498534 94.4046921 51.0498534 87.085044 29.2785924 87.085044 29.2785924 116.363636 36.5356794 116.363636"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "153.900293 178.674487 146.392962 178.674487 146.392962 203.78234 138.88563 203.78234 138.88563 210.956012 153.900293 210.956012"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "123.870968 204.199413 131.378299 204.199413 131.378299 211.706745 123.870968 211.706745"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCreateFromTemplate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Create_from_Template.c673a1c1.svg";
export { ForwardRef as ReactComponent };